<template>
    <div class="modal show text-left" tabindex="-1" role="dialog" aria-labelledby="myModalLabel335" aria-hidden="true" style="display:block;">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="myModalLabel335"><span class="text-primary text-md">Crop or adjust the uploaded image or document then save it to your profile.</span></h4>
                    <button type="button" class="close" aria-label="Close" v-on:click="closeCropper">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <!-- make the edged scallabe -->
                <div class="modal-body " v-if="userStore.img">
                    <div class="image_container">
                        <cropper
                            v-if='userStore.img'
                            class="cropper"
                            :src="userStore.img"

                            @change="change"
                            ref="cropper"
                        />
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12 d-flex flex-sm-row flex-column justify-content-center">
                        <slot name="saveCancel"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {ref} from 'vue';
import { Cropper } from 'vue-advanced-cropper'
import { useLocalizationStore } from '../../../../stores/LocalizationStore.js'
import { useUserStore } from '../../../../stores/UserStore.js'
import 'vue-advanced-cropper/dist/style.css';
export default{
    name:"crop-image-model",
    display:"crop image model",
    components: {
        Cropper,
    },
    setup(){
        const userStore = useUserStore(),
        showCropperModel=ref(false),
        keySaves = ref(0),
        fileSrc = ref(null);
        return{
            status,
            localizationStore: useLocalizationStore(),
            userStore,
            showCropperModel,
            fileSrc,
            keySaves,
        }
    },
    watch:{
    },
    mounted(){
    },
    methods:{
        
        showCropper(){
            this.userStore.showCropperModel = true;
        },
        converter(canvas){
            this.userStore.file = canvas.toDataURL(this.userStore.imageType);
        },
        change({ coordinates, canvas }) {
            this.converter(canvas)
		},

    }
}
</script>
<style>
.image-upload-loader{
    position: absolute;
    height: 100%;
    width: 100%;
    background: #0000008a;
    top: 0px;
    left: 0px;
    color: white;
    font-weight: bolder;
    text-align: center;
}
.image-upload-loader p{
    position: absolute;
    font-size: 15px;
    text-align: center;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}
</style>
